"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const starredMessagesTranslations = {
    unstarAll: "Unstar All",
    unstarAllConfirmation: "Are you sure you want to unstar all messages?",
    tapToUnstar: "Tap to unstar",
};
exports.default = starredMessagesTranslations;
